<template>
  <div class="wrapper address-wrapper">
    <section class="section address-section" v-for="item in addressList" :key="item.id" @click="setTopAddress(item)">
      <div class="content">
        <h3>
          <span>{{item.name}}</span>
          <span>{{item.phone}}</span>
        </h3>
        <p>{{item.province}} {{item.city}} {{item.district}} {{item.address}}</p>
      </div>
      <div class="bar">
        <label>
          <input type="radio" class="radio" name="address" :checked="checkedId === item.id"> 当前地址
        </label>
        <ul class="tools">
          <li @click.stop="onUpdate(item)">
            <i class="address-edit-icon"></i>编辑</li>
          <li @click.stop="onRemove(item)">
            <i class="address-delete-icon"></i>删除</li>
        </ul>
      </div>
    </section>
    <div class="btn-address">
      <router-link to="/my/address/add">添加新地址</router-link>
    </div>
  </div>
</template>
<script>
// 接口
import { getAddressList, deleteAddress, setTopAddress } from '@/api/address'
export default {
  name: 'AddressList',
  metaInfo: { title: '管理收货地址' },
  data() {
    return {
      addressList: [],
      checkedId: null,
      disabled: false
    }
  },
  methods: {
    // 获取收货地址列表
    getAddressList() {
      getAddressList().then(response => {
        this.addressList = response.data.list || []
        if (this.addressList.length) {
          this.checkedId = this.addressList[0].id
        }
      })
    },
    // 编辑
    onUpdate(item) {
      this.$router.push(`/my/address/update/${item.id}`)
    },
    // 删除
    onRemove(item) {
      this.$messagebox({
        title: '',
        message: '确定要删除此收货地址吗？',
        showCancelButton: true
      }).then(action => {
        if (action === 'confirm') {
          this.deleteAddress(item)
        }
      })
    },
    // 删除收货地址
    deleteAddress(item) {
      deleteAddress({ id: item.id }).then(response => {
        this.getAddressList()
      })
    },
    // 置顶收货地址
    setTopAddress(item) {
      if (this.disabled) {
        return false
      }
      this.disabled = true
      this.checkedId = item.id
      setTopAddress({ id: item.id })
        .then(response => {
          this.$router.go(-1)
          this.disabled = false
        })
        .catch(response => {
          this.disabled = false
        })
    }
  },
  created() {
    this.getAddressList()
  }
}
</script>
<style src='@/assets/css/address.css'></style>
